import React, { useContext } from 'react';


import { LanguageContext } from '../context/LanguageContext';
import commonTranslations from '../languages/common.json';


export const Configuration = () => {
	const { lang } = useContext(LanguageContext);
	const t = commonTranslations[lang].common;

	return (
		<div className="configuration">
			<h3>{t.configuration}</h3>
		</div>
	);
};
